module.exports = __webpack_public_path__ + "img/chinanet.479d8c58.svg";